import React, { useEffect, useState, useContext } from 'react'
import { useHistory, Link, useLocation  } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Menu, Sidebar, Icon, Segment, Container, Button, Image } from 'semantic-ui-react'
import { logout } from '../../actions/actionCreators'
import Logo from '../../images/logo-admin.png'
import { Text } from '../../helpers/language';


const AppSidebar = (props) => {

  const location = useLocation();

  const history= useHistory();

  const [visible, setVisible] = useState(false);

  const {content} = props

  useEffect(() => { 
   
  }, []);

  const do_logout = () => {
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'logout',
        label: 'User Logout',
        value: 'true'
    }
    });
    props.dispatch(logout())  
    toggleVisibility()
  }

  const toggleVisibility = () => {
    setVisible(!visible)
  }

  return (
    <Sidebar.Pushable as={Segment.Group} style={{ transform: "none" }} raised>
      <Sidebar
        as={Menu}
        animation='overlay'
        icon='labeled'
        onHide={() => setVisible(false)}
        inverted
        vertical
        visible={visible}
        width='thin'
        className='sidebar-menu'
        direction={'left'}
      >
        <Menu.Item as='a' className="sidebar-menu-item close_btn_menu_item" onClick={toggleVisibility}>
          <Icon className='close icon huge' />
        </Menu.Item>
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/'); toggleVisibility() }}>
            <Icon className='home' />
            <Text tid="sidebar_home" />
          </Menu.Item>
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/profile'); toggleVisibility() }}>
            <Icon className='user circle' />
            <Text tid="sidebar_profile" />
          </Menu.Item>
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/queryhistory'); toggleVisibility() }}>
            <Icon className='history' />
            <Text tid="sidebar_history" />
          </Menu.Item>
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/projects'); toggleVisibility() }}>
            <Icon className='folder open' />
            <Text tid="sidebar_directories" />
          </Menu.Item>
          { props.auth.type === 'user' ? 
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/subscription'); toggleVisibility() }}>
            <Icon className='money bill alternate' />
            <Text tid="sidebar_subscription" />
          </Menu.Item>
          :              
          <Menu.Item as='a' className="sidebar-menu-item" onClick={() => { history.push('/adminpage'); toggleVisibility() }}>
            <Icon className='table' />
            <Text tid="sidebar_admin_panel" />
          </Menu.Item>
          }
        <Menu.Item onClick={do_logout} className="sidebar-menu-item">
          <Icon className='sign-out' />
          <Text tid="sidebar_logout" />
        </Menu.Item>
      </Sidebar>
      <Sidebar.Pusher dimmed={visible} >
        <Segment basic>
          <div className="lisia-main-div">                             
            <Menu key='appbar' className='lisia-top-bar' size='tiny'>
              <Menu.Menu position={'left'} className='lisia-top-bar-content'> 

                <Button icon basic className="lisia-top-bar-button" onClick={toggleVisibility} >
                  <Icon name='bars' size='big' />
                </Button> 

                {location.pathname !== '/' && 
                  <Link to='/' >
                    <Image className='lisia-top-bar-logo' src={ Logo } />
                  </Link>                
                }
                
                <Button icon basic className="lisia-top-bar-button" onClick={do_logout} >
                  <Icon name='sign out alternate' size='big' />
                </Button>                              
                             
              </Menu.Menu>             
            </Menu>            
              <Container className='full-width'>                    
                <Row className='lisia-dashboard-content'>
                  <Col md={12} xs={12}>
                    {content}
                  </Col>
                </Row>
              </Container>            
          </div>
        </Segment>
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );  
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps)(AppSidebar)
